@if (steps.length > 0) {
  <div class="flex flex-row gap-2 px-9 py-3" [ngClass]="class" [ngStyle]="style">
    @for (step of steps; track trackByFn($index, step)) {
      <div class="flex w-full flex-col">
        <div
          class="flex h-[26px] w-[26px] flex-col items-center justify-center rounded-[13px] border-2 border-gray-300 text-gray-300"
          [ngClass]="{ 'border-primary text-primary': step.active }">
          <div class="font-bold">{{ step.step }}</div>
        </div>
        <div class="my-[7px] h-[2px] bg-gray-300" [ngClass]="{ 'bg-primary': step.active }"></div>
        <p class="text-sm font-semibold text-gray-300" [ngClass]="{ 'text-primary': step.active }">{{ step.title }}</p>
      </div>
    }
  </div>
}
